import Request from '@/core/QuRequest';

const req = new Request();
const SELECTABLE_FILTER_FIELDS = [
  'account_ids',
  'agent_ids',
  'budget_ids',
  'product_ids',
  'user_sub_agent_ids',
  'sale_ids',
  'product_series_ids',
  'new_series_id',
  // 'slot_names',
  'task_ids',
];

export default {
  methods: {
    formatSelectableFilterValue(value) {
      return Array.isArray(value) && value.length > 0 ? value.join(',') : '';
    },

    getSelectableFilterMode(field) {
      const value = this[`${field}_mode`];
      return value || 'include';
    },

    getSelectableFilterParams() {
      return SELECTABLE_FILTER_FIELDS.reduce((prev, field) => {
        const value = this.formatSelectableFilterValue(this[field]);

        prev[field] = value;
        prev[`${field}_type`] = value
          ? this.getSelectableFilterMode(field)
          : '';

        return prev;
      }, {});
    },

    getSingleFilterParams() {
      return {
        idea_type: this.idea_type || '',
        plan_action_type: this.plan_action_type,
        is_rta:
          this.is_rta === undefined || this.is_rta === null ? '' : this.is_rta,
        charge_type: this.charge_type,
      };
    },

    getFilterParams() {
      return {
        ...this.getSelectableFilterParams(),
        ...this.getSingleFilterParams(),
      };
    },

    normalizeFilterKeyword(keyword) {
      return String(keyword || '')
        .trim()
        .toLowerCase();
    },

    mergeUniqueOptions(options = []) {
      const optionMap = new Map();

      (options || []).forEach((item) => {
        if (
          !item ||
          item.value === undefined ||
          item.value === null ||
          item.value === ''
        ) {
          return;
        }

        const key = String(item.value);
        if (!optionMap.has(key)) {
          optionMap.set(key, item);
        }
      });

      return Array.from(optionMap.values());
    },

    filterOptionsByKeyword(options = [], keyword = '') {
      const normalizedKeyword = this.normalizeFilterKeyword(keyword);

      if (!normalizedKeyword) {
        return options;
      }

      return options.filter((item) => {
        const label = this.normalizeFilterKeyword(item.label);
        const value = this.normalizeFilterKeyword(item.value);

        return (
          label.includes(normalizedKeyword) || value.includes(normalizedKeyword)
        );
      });
    },

    getSelectedOptions(options = [], values) {
      const valueList = Array.isArray(values) ? values : [values];

      return valueList
        .filter((item) => item !== undefined && item !== null && item !== '')
        .map((value) => {
          const matched = (options || []).find(
            (item) => String(item.value) === String(value),
          );

          return (
            matched || {
              label: String(value),
              value,
            }
          );
        });
    },

    formatTextOption(value) {
      if (value === undefined || value === null || value === '') {
        return null;
      }

      const text = String(value).trim();

      if (!text) {
        return null;
      }

      return {
        label: text,
        value: text,
      };
    },

    formatSubAccountOption(item = {}) {
      const value = item.user_sub_agent_id;
      const label = [item.user_sub_agent_id, item.user_sub_agent_name]
        .filter(Boolean)
        .join(' / ');

      if (!value || !label) {
        return null;
      }

      return {
        label,
        value,
      };
    },

    formatIsRtaOption(value) {
      if (value === undefined || value === null || value === '') {
        return null;
      }

      const text = String(value).trim();
      const normalized = text.toLowerCase();
      let label = text;

      if (['1', 'true', 'yes', 'y', '\u662f'].includes(normalized)) {
        label = '\u662f';
      } else if (['0', 'false', 'no', 'n', '\u5426'].includes(normalized)) {
        label = '\u5426';
      }

      return {
        label,
        value,
      };
    },

    // syncDynamicFilterOptions(list = []) {
    //   const rows = Array.isArray(list) ? list : [];

    //   const nextSubAccountSourceOptions = this.mergeUniqueOptions([
    //     ...rows
    //       .map((item) => this.formatSubAccountOption(item))
    //       .filter(Boolean),
    //     ...this.getSelectedOptions(
    //       this.subAccountSourceOptions,
    //       this.user_sub_agent_ids,
    //     ),
    //   ]);
    //   this.subAccountSourceOptions = nextSubAccountSourceOptions;
    //   this.SubAccountOptions = this.filterOptionsByKeyword(
    //     nextSubAccountSourceOptions,
    //   );

    //   this.ideaTypeOptions = this.mergeUniqueOptions([
    //     ...rows
    //       .map((item) => this.formatTextOption(item.idea_type))
    //       .filter(Boolean),
    //     ...this.getSelectedOptions(this.ideaTypeOptions, this.idea_type),
    //   ]);

    //   const nextSlotNameSourceOptions = this.mergeUniqueOptions([
    //     ...rows
    //       .map((item) => this.formatTextOption(item.slot_name))
    //       .filter(Boolean),
    //     ...this.getSelectedOptions(this.slotNameSourceOptions, this.slot_names),
    //   ]);
    //   this.slotNameSourceOptions = nextSlotNameSourceOptions;
    //   this.slotNameOptions = this.filterOptionsByKeyword(
    //     nextSlotNameSourceOptions,
    //   );

    //   const nextIsRtaOptions = this.mergeUniqueOptions([
    //     ...rows
    //       .map((item) => this.formatIsRtaOption(item.is_rta))
    //       .filter(Boolean),
    //     ...this.getSelectedOptions(this.isRtaOptions, this.is_rta),
    //   ]);
    //   if (nextIsRtaOptions.length > 0) {
    //     this.isRtaOptions = nextIsRtaOptions;
    //   }

    //   const nextBidTypeOptions = this.mergeUniqueOptions([
    //     ...rows
    //       .map((item) => this.formatTextOption(item.charge_type))
    //       .filter(Boolean),
    //     ...this.getSelectedOptions(this.bidTypeOptions, this.charge_type),
    //   ]);
    //   if (nextBidTypeOptions.length > 0) {
    //     this.bidTypeOptions = nextBidTypeOptions;
    //   }
    // },

    // 获取公共参数
    getParams() {
      const [start, end] = this.date;
      const params = {
        start_date: start.format(this.$REQUEST_DATE_FORMAT),
        end_date: end.format(this.$REQUEST_DATE_FORMAT),
        stop_days: this.stopDays,
        keyword: this.keyword,
        aggregatedType: this.aggregatedType,
        budgetType: this.budgetType,
      };
      return params;
    },

    // 获取汇总信息
    async querySummary() {
      const params = this.getParams();
      const data = await req.send(
        req.Apis.sales.report.productReportSummary,
        params,
      );

      try {
        const { list, latestTime } = data.data;
        this.summary = list;
        this.summaryLoading = false;
        this.lastUpdateTime = latestTime;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取停投产品数
    async queryStopProductSummary() {
      const params = this.getParams();
      const data = await req.send(
        req.Apis.sales.report.productReportSummaryStop,
        params,
      );

      try {
        this.summary = this.summary.map((item) => {
          if (item.key === data.data.key) return data.data;
          return item;
        });
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取汇总折线图数据
    async queryMyPerformance() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.index = this.field;
      params.sale_type = this.sale_type;
      // params.name = this.name;
      // params.sale_name = this.sale_name;
      Object.assign(params, this.getFilterParams());
      params.customer_cate = this.customer_cate;

      const data = await req.send(
        req.Apis.sales.report.agentReportMyPerformance,
        params,
      );

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取产品系KA列表
    async queryProductSeries(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.list, {
        keyword: keyword,
      });
      if (res.code === 200) {
        const { data } = res;
        this.productSeriesOptions = (data.list || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },

    // 获取产品系列表
    async queryProductSeriesAll(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.listAll, {
        keyword: keyword,
        page_size: 1000
      });
      if (res.code === 200) {
        const { data } = res;
        this.productSeriesAllOptions = (data.list || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },

    // 获取广告主列表
    async queryAccounts(keyword) {
      if (!keyword) {
        this.accountOptions = [];
        return false;
      }
      // type 账号类型，枚举值：0-广告主，1-代理商
      const res = await req.send(req.Apis.customer.common.userList, {
        keyword,
        type: 0,
      });
      if (res.code === 200) {
        this.accountOptions = (res.data || []).map((item) => ({
          label: item.username,
          value: item.id,
        }));
      }
    },

    // 获取代理商列表
    async queryAgents(keyword) {
      if (!keyword) {
        this.agentOptions = [];
        return false;
      }

      const res = await req.send(req.Apis.customer.common.userList, { keyword, type: 1 });
      if (res.code === 200) {
        this.agentOptions = (res.data || []).map((item) => ({
          label: item.display_name,
          value: item.id,
        }));
      }
    },

    async querySubAccounts(keyword) {
      if (!keyword) {
        this.SubAccountOptions = [];
        return false;
      }

      const res = await req.send(req.Apis.customer.common.userList, { keyword, type: 3 });
      if (res.code === 200) {
        this.SubAccountOptions = (res.data || []).map((item) => ({
          label: item.username,
          value: item.id,
        }));
      }
    },

    // 获取任务列表
    async queryTasks(keyword) {
      const res = await req.send(req.Apis.customer.taskTag.list, {
        keyword: keyword,
        page_size: 9999,
      });
      if (res.code === 200) {
        const { data } = res;
        this.taskOptions = (data.list || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },

    // 获取聚合名称
    async queryAggregations(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.aggregations, {
        page: 1,
        page_size: 100,
        keyword: keyword,
      });
      if (res.code === 200) {
        const { data } = res;
        this.aggregationsOptions = (data.list || []).map((item) => {
          return { label: item.budget_name, value: item.id };
        });
      }
    },

    // 获取产品名称
    async queryProducts(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.products, {
        name: keyword,
        page: 1,
        page_size: 100,
      });
      if (res.code === 200) {
        const { data } = res;
        this.productsOptions = (data.data || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },

    // 获取销售名称/所属
    async queryProductSales(keyword) {
      const res = await req.send(req.Apis.customer.productSeries.sales, {
        names: keyword,
        page: 1,
        page_size: 100,
        is_report: 1
      });
      if (res.code === 200) {
        const { data } = res;
        this.salesOptions = (data.data || []).map((item) => {
          return { label: item.name, value: item.id };
        });
      }
    },

    querySlotNames(keyword) {
      this.slotNameOptions = this.filterOptionsByKeyword(
        this.slotNameSourceOptions,
        keyword,
      );
    },

    // 获取 TOP10 折线图数据
    async queryTopTen() {
      const params = this.getParams();
      params.dimension = this.dimension;
      params.index = this.field;
      params.sale_type = this.sale_type;
      // params.name = this.name;
      // params.sale_name = this.sale_name;
      Object.assign(params, this.getFilterParams());
      params.customer_cate = this.customer_cate;

      const data = await req.send(
        req.Apis.sales.report.agentReportTopTen,
        params,
      );

      try {
        this.rawChartData = data.data;
        this.chartLoading = false;
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    // 获取详细数据列表
    async queryList() {
      const params = this.getParams();
      params.page = this.page;
      params.page_size = this.pageSize;
      params.order_by = this.order;
      params.dimension = 'common';
      params.filters = this.filters;
      params.fields = [...this.fields]
        .join(',')
        .replace('direct_sale2', 'direct_sale');
      // params.name = this.name;
      params.sale_type = this.sale_type;
      // params.sale_name = this.sale_name;
      Object.assign(params, this.getFilterParams());
      params.customer_cate = this.customer_cate;
      params.dimensionBy = this.dimensionBy;

      const data = await req.send(
        req.Apis.sales.report.agentReportList,
        params,
      );

      try {
        this.tableLoading = false;
        this.rawTableData = data.data;
        // this.syncDynamicFilterOptions((data.data || {}).list || []);
      } catch (err) {
        this.$message.error(`获取详细数据失败：${err.message || '未知错误'}`);
      }
    },

    async download() {
      // const form = document.createElement('form');
      // form.id = 'downloadForm';
      // form.name = 'tableDownloadHelper';
      // document.body.appendChild(form);
      // for (let key in params) {
      //   if (params.hasOwnProperty(key)) {
      //     if (key !== 'filters') {
      //       const input = document.createElement('input');
      //       input.type = 'hidden';
      //       input.name = key;
      //       input.value = params[key];
      //       form.appendChild(input);
      //     } else {
      //       params[key].forEach((value) => {
      //         const input = document.createElement('input');
      //         input.type = 'hidden';
      //         input.name = 'filters[]';
      //         input.value = value;
      //         form.appendChild(input);
      //       });
      //     }
      //   }
      // }
      // form.method = 'POST';
      // form.action = req.getUrl(req.Apis.sales.report.productReportDownload);
      // form.submit();
      // document.body.removeChild(form);
    },
  },
};
